<template>
  <div
    @click="passMethod('click')"
    :class="[
      classes,
      $platformClass,
      pointClass,
      isDtmslg ? 'is-dtmslg' : '',
      isUsArea ? 'is-us-area' : ''
    ]"
    class="j-inner-pay-btn"
  >
    <div class="inner-tips" style="display: none">
      {{ languages.morePurchaseWay }}
    </div>
    <div
      v-if="isDlssr || isDl3dvn || isBeast"
      class="inner-game-logo"
      :class="[curLanguage]"
    ></div>
    <span :class="[logoClass, $platformClass]"></span>
    <div class="inner-pay-price-wrap" v-if="showDiscount">
      <Button class="pay-btn" type="selectInnerWay">
        {{ btnText }}
      </Button>
    </div>
    <Button class="pay-btn" type="selectInnerWay" v-else>
      {{ btnText }}
      <Icon v-if="!$isOmni" type="selectInnerPay"></Icon>
    </Button>
  </div>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: [
    'languages',
    'logoClass',
    'isMuglo',
    'isBeast',
    'isDlssr',
    'isDl3dvn',
    'curLanguage',
    'isDtmslg',
    'isUsArea',
    'iaPrice',
    'showDiscount',
    'hasDiscount'
  ],
  computed: {
    btnText() {
      if (this.isMuglo || this.isBeast || this.isDlssr || this.isDl3dvn) {
        return this.languages.payBtn;
      }
      if (this.showDiscount) {
        return `${this.languages.pay}>>`;
      }
      return this.languages.payBtnText;
    },
    showPrice() {
      if (this.iaPrice?.currency === '$') {
        return `$${this.iaPrice?.price} >>`;
      }
      return `${this.iaPrice?.price}${this.iaPrice?.currency} >>`;
    }
  }
};
</script>
